import { jsxs as w, jsx as t, Fragment as L } from "react/jsx-runtime";
import * as u from "react";
import { forwardRef as x, useRef as ee, useImperativeHandle as te, useMemo as b, useState as re, cloneElement as ne, isValidElement as le, memo as ae } from "react";
import { c as m } from "./tw-cn-mXgPecoF.mjs";
import { c as F } from "./index.js-Cr0Rsuyz.mjs";
import { u as ie } from "./use-focus-BGKOEgog.mjs";
import { I as H } from "./icon-button-CBGiAhhG.mjs";
import { c as A } from "./variance-DhhqoHkK.mjs";
function se(e, r) {
  return /* @__PURE__ */ u.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: r
  }, e), /* @__PURE__ */ u.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.25c5.385 0 9.75 4.365 9.75 9.75s-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25m4.064 5.688a.75.75 0 0 0-1.06 0l-3.009 3.008-3.009-3.008a.75.75 0 0 0-1.06 1.06l3.009 3.009-3.002 3.002a.75.75 0 1 0 1.06 1.06l3.002-3.002 3.002 3.002a.75.75 0 0 0 1.06-1.06l-3.001-3.002 3.008-3.009a.75.75 0 0 0 0-1.06",
    clipRule: "evenodd"
  }));
}
var oe = F(/* @__PURE__ */ x(se));
function ue(e, r) {
  return /* @__PURE__ */ u.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: r
  }, e), /* @__PURE__ */ u.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.339 4.722a.75.75 0 0 0-1.061-1.06L3.661 20.277a.75.75 0 1 0 1.06 1.06l3.46-3.459c1.223.44 2.524.683 3.819.683 4.275 0 8.616-2.663 10.012-6.21a2.24 2.24 0 0 0 0-1.64c-.562-1.43-1.602-2.715-2.923-3.74zm-3.32 3.32-2.02 2.019a4.25 4.25 0 0 1-5.44 5.44l-1.187 1.188a9.7 9.7 0 0 0 2.628.373c3.768 0 7.483-2.38 8.616-5.26a.74.74 0 0 0 0-.542c-.475-1.206-1.403-2.325-2.598-3.218",
    clipRule: "evenodd"
  }), /* @__PURE__ */ u.createElement("path", {
    fill: "currentColor",
    d: "M15.965 5.237A11.4 11.4 0 0 0 12 4.5c-4.276 0-8.616 2.663-10.012 6.211a2.24 2.24 0 0 0 0 1.64c.578 1.47 1.661 2.788 3.036 3.827l1.073-1.073c-1.25-.906-2.224-2.058-2.714-3.303a.74.74 0 0 1 0-.542C4.517 8.381 8.232 6 12 6c.944 0 1.885.15 2.784.42z"
  }), /* @__PURE__ */ u.createElement("path", {
    fill: "currentColor",
    d: "M13.63 7.573a4.25 4.25 0 0 0-5.556 5.556l1.208-1.208a2.75 2.75 0 0 1 3.139-3.139z"
  }));
}
var ce = F(/* @__PURE__ */ x(ue));
function pe(e, r) {
  return /* @__PURE__ */ u.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: r
  }, e), /* @__PURE__ */ u.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 7.25a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5M9.25 11.5a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0",
    clipRule: "evenodd"
  }), /* @__PURE__ */ u.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 4.5c-4.276 0-8.616 2.663-10.012 6.211a2.24 2.24 0 0 0 0 1.64C3.384 15.9 7.724 18.562 12 18.562c4.275 0 8.616-2.663 10.012-6.21a2.24 2.24 0 0 0 0-1.64C20.616 7.162 16.275 4.5 12 4.5m-8.617 6.76C4.517 8.382 8.232 6 12 6s7.483 2.381 8.616 5.26a.74.74 0 0 1 0 .542c-1.133 2.88-4.848 5.26-8.616 5.26s-7.483-2.38-8.617-5.26a.74.74 0 0 1 0-.541",
    clipRule: "evenodd"
  }));
}
var de = F(/* @__PURE__ */ x(pe));
const fe = ["default", "large"], me = A(["border border-solid relative flex items-center rounded-12 py-4 px-16"], {
  variants: {
    mobileSize: {
      default: "min-h-44",
      large: "min-h-56"
    },
    pcSize: {
      default: "pc:min-h-44",
      large: "pc:min-h-56"
    },
    isFocused: {
      true: "border px-15",
      false: ""
    },
    isShowRightIconButton: {
      true: "",
      false: ""
    }
  },
  compoundVariants: [
    ...fe.flatMap((e) => [
      {
        isFocused: !1,
        mobileSize: e,
        isShowRightIconButton: !0,
        className: e === "default" ? "pr-8" : "rounded-16 pr-10"
      },
      {
        isFocused: !0,
        mobileSize: e,
        isShowRightIconButton: !0,
        className: e === "default" ? "pr-7" : "rounded-16 pr-9"
      },
      {
        isFocused: !1,
        pcSize: e,
        isShowRightIconButton: !0,
        className: e === "default" ? "pc:pr-8" : "rounded-16 pc:pr-10"
      },
      {
        isFocused: !0,
        pcSize: e,
        isShowRightIconButton: !0,
        className: e === "default" ? "pc:pr-7" : "rounded-16 pc:pr-9"
      }
    ])
  ],
  defaultVariants: {
    mobileSize: "default",
    pcSize: "default",
    isShowRightIconButton: !1,
    isFocused: !1
  }
}), he = A(
  [
    "size-full placeholder:text-text-neutral-medium disabled:text-interaction-neutral-disable-main disabled:placeholder:text-interaction-neutral-disable-main disabled:bg-fill-neutral-weak",
    // number 타입 input의 화살표 숨김
    "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
  ],
  {
    variants: {
      mobileSize: {
        default: "typography-subtitle-16-regular",
        large: "typography-subtitle-18-regular"
      },
      pcSize: {
        default: "pc:typography-subtitle-16-regular",
        large: "pc:typography-subtitle-18-regular"
      },
      // 읽기 전용은 글자색이 달라지고 캐럿을 감춘다. 두 값이 함께 나가지 않도록 base 에서 글자색을 뺐다.
      // input 의 브라우저 기본 배경은 흰색이라, wrapper 뿐 아니라 input 에도 배경을 줘야 패딩 영역만 회색으로 남지 않는다.
      isReadOnly: {
        true: "bg-fill-neutral-weak text-text-neutral-sub caret-transparent",
        false: "text-text-neutral-main"
      }
    },
    defaultVariants: {
      mobileSize: "default",
      pcSize: "default",
      isReadOnly: !1
    }
  }
), ge = (e) => le(e) && e.type === "button", xe = ({ children: e }) => ge(e) ? ne(e, { tabIndex: -1 }) : e, C = x(
  ({
    id: e,
    type: r = "text",
    value: n,
    disabled: l,
    onChange: i,
    onBlur: f,
    hasError: c = !1,
    placeholder: o,
    mobileSize: p = "default",
    pcSize: h = "default",
    rightTextButton: S,
    onClearCallback: v,
    onPasswordToggleCallback: g,
    showPasswordVisibleButton: B,
    showClearButton: D = !1,
    inputWrapperClassName: G,
    inputClassName: M,
    suffix: V,
    isReadOnly: d = !1,
    ...J
  }, K) => {
    var T, k;
    const s = ee(null), { isFocused: N } = ie(s);
    te(K, () => s.current);
    const z = b(() => p === "default" ? "small" : "medium", [p]), j = b(() => h === "default" ? "small" : "medium", [h]), [y, Q] = re(!1), U = me({
      mobileSize: p,
      pcSize: h,
      // 읽기 전용은 테두리 색만 바뀌므로 포커스에 따른 여백 보정을 쓰지 않는다.
      isFocused: d ? !1 : N,
      isShowRightIconButton: !!(!d && (D || B))
    }), E = he({ mobileSize: p, pcSize: h, isReadOnly: d }), X = l || d ? "bg-fill-neutral-weak" : "bg-static-white", Y = b(() => l ? "border-line-neutral-weak3" : d ? "border-line-neutral-weak3 has-[:focus-visible]:border-line-neutral-main" : c ? "border-line-danger-main caret-text-danger-main" : N ? "border-line-primary-main caret-fill-primary-main" : "border-line-neutral-weak3", [l, d, c, N]), Z = (a) => {
      f == null || f(a);
    }, _ = (a) => {
      a.preventDefault();
      const I = s.current;
      I && (I.value = "", W(), i && i({
        target: I,
        currentTarget: I
      })), v == null || v();
    }, W = () => {
      if (s.current) {
        const a = s.current.value.length || (n == null ? void 0 : n.toString().length) || 0;
        window.setTimeout(() => {
          s.current && s.current.setSelectionRange(a, a);
        }, 0), s.current.focus();
      }
    }, $ = () => {
      Q(!y), W(), g == null || g();
    }, P = (a) => {
      i == null || i(a);
    }, O = b(() => r === "password" ? y ? "text" : "password" : r, [r, y]);
    return /* @__PURE__ */ w("div", { className: m(U, X, Y, G), children: [
      /* @__PURE__ */ t(
        "input",
        {
          className: m(E, M),
          disabled: l,
          id: e,
          onBlur: Z,
          onChange: P,
          placeholder: o,
          readOnly: d,
          ref: s,
          type: O,
          value: n,
          ...J
        }
      ),
      V && (n || (T = s.current) != null && T.value) ? /* @__PURE__ */ w("div", { className: "pointer-events-none absolute left-0 top-0 flex h-full items-center", children: [
        /* @__PURE__ */ t("span", { className: m(E, M, "invisible"), children: n }),
        /* @__PURE__ */ t(
          "span",
          {
            className: m(
              E,
              "text-text-tertiary ml-22 flex items-center",
              l ? "text-interaction-neutral-disable-main" : ""
            ),
            children: V
          }
        )
      ] }) : null,
      !l && !d ? /* @__PURE__ */ t(L, { children: S ? /* @__PURE__ */ t(xe, { children: /* @__PURE__ */ t("div", { className: "pl-8", children: S }) }) : (n || ((k = s.current) == null ? void 0 : k.value)) && /* @__PURE__ */ w(L, { children: [
        D ? /* @__PURE__ */ t(
          H,
          {
            icon: /* @__PURE__ */ t(oe, {}),
            onClick: _,
            onMouseDown: (a) => {
              a.preventDefault();
            },
            size: { mobile: z, pc: j },
            tabIndex: -1,
            theme: "ghost"
          }
        ) : null,
        r === "password" && B ? /* @__PURE__ */ t(
          H,
          {
            icon: y ? /* @__PURE__ */ t(de, {}) : /* @__PURE__ */ t(ce, {}),
            onClick: $,
            onMouseDown: (a) => {
              a.preventDefault();
            },
            size: { mobile: z, pc: j },
            tabIndex: -1,
            theme: "ghost"
          }
        ) : null
      ] }) }) : null
    ] });
  }
);
C.displayName = "NDS.Input";
const q = x(({ children: e, ...r }, n) => /* @__PURE__ */ t("label", { ref: n, ...r, className: "flex-start flex px-4", children: typeof e == "string" ? /* @__PURE__ */ t("span", { className: "text-text-neutral-main typography-body-13-semibold", children: e }) : e }));
q.displayName = "NDS.Label";
const R = ({ leftContent: e, rightContent: r, hasError: n, disabled: l, isReadOnly: i }) => {
  const f = b(() => l ? "text-interaction-neutral-disable-main" : n ? "text-text-danger-main" : i ? "text-text-neutral-sub" : "text-text-neutral-main", [l, n, i]), c = (o, p) => typeof o == "string" ? /* @__PURE__ */ t("span", { className: p, children: o }) : o;
  return /* @__PURE__ */ w("div", { className: "flex w-full justify-between px-4 text-left", children: [
    e ? /* @__PURE__ */ t("div", { className: "mr-8", children: c(e, m("line-clamp-2 typography-body-12-regular-multiline", f)) }) : null,
    r ? /* @__PURE__ */ t("div", { className: "ml-auto", children: c(r, m("whitespace-nowrap text-text-neutral-main typography-body-12-regular")) }) : null
  ] });
};
R.displayName = "NDS.Support";
ae(R);
const ve = x(
  ({
    className: e,
    id: r,
    label: n,
    supportLeftContent: l,
    supportRightContent: i,
    hasError: f = !1,
    disabled: c = !1,
    isReadOnly: o = !1,
    inputRef: p,
    suffix: h,
    ...S
  }, v) => {
    const g = o ? !1 : f;
    return /* @__PURE__ */ w("div", { className: m("flex w-full flex-col gap-8", e), ref: v, children: [
      n ? /* @__PURE__ */ t(q, { htmlFor: r, children: n }) : null,
      /* @__PURE__ */ t(
        C,
        {
          disabled: c,
          hasError: g,
          id: r,
          isReadOnly: o,
          ref: p,
          suffix: h,
          ...S
        }
      ),
      l || i ? /* @__PURE__ */ t(
        R,
        {
          disabled: c,
          hasError: g,
          isReadOnly: o,
          leftContent: l,
          rightContent: i
        }
      ) : null
    ] });
  }
);
ve.displayName = "NDS.TextField";
export {
  ve as T
};
